/**
 * Recursively trims all string values in an object.
 * Safely skips null, undefined, non-object types, and class instances (Timestamp, FieldValue, etc.).
 * Use at Firestore save boundaries to sanitize user input.
 */
export function trimStrings<T>(obj: T): T {
  if (typeof obj === 'string') return obj.trim() as T;
  if (obj === null || obj === undefined || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(trimStrings) as T;
  if (!isPlainObject(obj)) return obj;
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    result[key] = trimStrings(value);
  }
  return result as T;
}

export function isPlainObject(obj: unknown): boolean {
  if (typeof obj !== 'object' || obj === null) return false;
  const proto = Object.getPrototypeOf(obj);
  return proto === Object.prototype || proto === null;
}
